/**
 * API Client
 * Simple wrapper around apiService for backward compatibility
 */

import { apiService } from './apiService';

// Export apiService as apiClient for backward compatibility
// Properly expose all methods from the apiService instance
export const apiClient = {
  get: apiService.get.bind(apiService),
  post: apiService.post.bind(apiService),
  put: apiService.put.bind(apiService),
  patch: apiService.patch.bind(apiService),
  delete: apiService.delete.bind(apiService),
  uploadFile: apiService.uploadFile.bind(apiService),
  getBaseURL: apiService.getBaseURL.bind(apiService),
  getApiCallLogs: apiService.getApiCallLogs.bind(apiService),
  clearApiCallLogs: apiService.clearApiCallLogs.bind(apiService),
};
export default apiClient;
